import React, { Component } from 'react';

import InputCustom from '../../components/default/InputCustom'
import ButtonCustom from '../../components/default/ButtonCustom'
import LinkCustom from '../../components/default/LinkCustom'

class ForgotPassword extends Component {
    render() {
        return (
            <form action="" method="post">
                <div className="login-section-wrap">
                    <div className="login-section">
                        <div className="login-section-title">ลืมรหัสผ่าน?</div>
                        <div className="login-section-sub-title gapb-32">ระบบจะส่งข้อมูลการตั้งรหัสผ่านใหม่ไปยังอีเมล</div>
                        <InputCustom
                            label="อีเมล"
                            labelColor="65"
                            size="large"
                            type="password"
                            required
                            placeholder="อีเมล"
                            marginBottom="16"
                        />
                        <div className="gapb-24 gapt-32">
                            <ButtonCustom
                                borderRadius="4"
                                color="blue"
                                label="ยืนยัน"
                                fontSize={14}
                                fontWeight="Bold"
                                size="large"
                            />
                        </div>
                        <div className="textAlign-center">
                            <LinkCustom label="เข้าสู่ระบบ" link="/login" />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default ForgotPassword;
